/*
*
* File JS componente BLOCK PODCAST
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination } from 'swiper';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-podcast.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

const initSwiper = () => {
    let elSwiperPodcast = document.querySelector('.block-podcast .swiper-container');

    if(!elSwiperPodcast) return;

    Swiper.use([Navigation, Pagination]);

    const args = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 600,
        centeredSlides: true,
        loop: true,
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
    };
    
    let swiperMag = new Swiper(elSwiperPodcast, args);
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockPodcast = () => {

    initSwiper();

}

export default blockPodcast;

//--------------------------------------------------------------------//